
import FormElement
    from "./FormElement";
import SanitizedHTML from 'react-sanitized-html';

const FormLabelField = ({
                           template,
                           values,
                           defaultAnswer,
                           onChange,
                           onBlur,
                           disabled = false,
                           defaultAnswers,
                           ...rest
                       }) => {
    const {
        id,
        content,
    } = template;

    const {
        question,
        ignoreIfHidden,
        value
    } = content;

    return (
        <FormElement id={id} label={question} hiddenLabel={true} className="fz-form-element-label">
            <SanitizedHTML
                allowedTags={['p', 'h1', 'h2', 'h3', 'h4', 'div', 'ul', 'ol', 'u', 'strong']}
                allowedAttributes={{'*': ['class']}}
                html={ value }
            />
        </FormElement>
    )
}

export default FormLabelField;